const path = '/img/products/sound-matrix';

export const BANNER_DATA = {
  title: 'SoundMatrix A10，智能会议麦克风音箱',
  slogan: '为您的高质量会议保驾护航',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/banner-mobile.webp`,
  description: [
    {
      title: 'AI智能算法',
      desc: '快手自研技术',
    },
    {
      title: '豪华硬件配置',
      desc: '追求极致设计',
    },
    {
      title: '即插即用',
      desc: '多平台兼容',
    },
  ],
  buttonText: '立即购买',
  businessLink: 'https://item.jd.com/10067285691814.html',
  linkText: '申请试用',
  experienceLink: '/form/consult/experience-sound-matrix',
};

export const FEATURES = {
  title: 'SoundMatrix A10，\n为您的高质量会议保驾护航',
  items: [
    {
      title: 'AI智能降噪',
      picUrl: `${path}/icon1.webp`,
    },
    {
      title: 'AI回声消除',
      picUrl: `${path}/icon2.webp`,
    },
    {
      title: 'AI混响抑制',
      picUrl: `${path}/icon3.webp`,
    },
    {
      title: '超远拾音',
      picUrl: `${path}/icon4.webp`,
    },
    {
      title: '顶级定制音腔',
      picUrl: `${path}/icon5.webp`,
    },
    {
      title: '即插即用',
      picUrl: `${path}/icon6.webp`,
    },
  ],
};

export const SECTION1 = {
  title: '360度全向拾音，高品质全双工技术，还原清晰人声',
  desc: '主设备配备四个高信噪比数字麦克风，搭配行业领先的AI回声消除算法，实现准确定位发言人方位，全面消除回声杂音，确保语音连续自然，让远程开会更畅通，打造面对面沟通极致体验！',
  picUrl: `${path}/section1.webp`,
  picUrlMobile: `${path}/section1-mobile.webp`,
};

export const SECTION2 = {
  title: '扩展麦克风，10米半径超远拾音',
  desc: '通过连接2个扩展麦克风，实现更远距离的语音拾取和传输，支持超大规模会议室',
  picUrl: `${path}/section2.webp`,
  picUrlMobile: `${path}/section2-mobile.webp`,
};

export const SECTION3 = {
  title: '全球顶级音腔设计制造',
  desc: '采用高低频喇叭设计，由顶级音效工程师调音，使得播放音乐低音浑厚、高音透彻，播放语音清晰自然',
  picUrl: `${path}/section3.webp`,
  picUrlMobile: `${path}/section3-mobile.webp`,
};

export const SECTION4 = {
  title: '即插即用，一根USB-C连接电脑',
  desc: '使用数据线连接设备与电源和电脑，即可实现会议麦克风、摄像头、投屏、反向充电4个功能，提供更简单的使用方式，轻松打造理想会议室',
  picUrl: `${path}/section4.webp`,
  picUrlMobile: `${path}/section4-mobile.webp`,
};

export const SECTION5 = {
  title: 'AI智能降噪、AI回声消除、AI混响抑制、自动增益',
  desc: '采用行业领域内全面领先的技术，实现在会议场景中，全面消除空间背景噪声和语音混响，实现根据声音大小自动调节增益，输出高清音质，让远程开会更清晰！',
  picUrl: `${path}/section5.webp`,
  picUrlMobile: `${path}/section5-mobile.webp`,
};

export const SECTION6 = {
  title: '多平台兼容',
  desc: 'Windows、Mac、Android、Linux\n兼容多种主流会议软件',
  picUrl: `${path}/section6.webp`,
  picUrlMobile: `${path}/section6-mobile.webp`,
};
export const SECTION7 = {
  title: '最佳拍档，快速搭建会议室',
  desc: 'SoundMatrixV10 4K超高清摄像头\n更高清、更纯净、更便捷',
  picUrl: `${path}/section7.webp`,
  picUrlMobile: `${path}/section7.webp`,
};

export const TIP = {
  hint: '若想咨询详情，可立即联系我们：',
  highlight: 'SoundMatrix@streamlake.com',
};
